import type { PageGuide } from "../page-guide.js";

/**
 * Help guide for the admin-only Partner vaults console (ADR-0106).
 *
 * Two things here are genuinely non-obvious and worth teaching rather than
 * leaving to discovery: what this screen deliberately cannot do (create or
 * decommission a partner), and what "personal" actually means for visibility.
 */
export const partnerVaultsGuide: PageGuide = {
  route: "/partner-vaults",
  version: 1,
  overviewArticleId: "partner-vaults-overview",
  steps: [
    {
      id: "pick-partner",
      title: "Pick a partner first",
      body: "Everything on this page is scoped to the partner in the **Partner** selector. Switching partner switches which tenant's workspaces you are creating and archiving.",
    },
    {
      id: "personal-vaults",
      title: "Personal vaults are owner-only",
      body: "Ticking **Personal vault** and naming an owner makes the workspace visible to **that person and administrators only**. Roles do not open a personal vault — not even a role that would normally see everything.",
    },
    {
      id: "archive-is-reversible",
      title: "Archiving is reversible",
      body: "Archiving hides a workspace and its documents from everyone except administrators. Nothing is deleted, and the SharePoint files it points at are untouched. Tick **Show archived** to see and restore them.",
    },
  ],
  panels: [],
  guidedActions: [],
};
